import { publicClient, privateClient } from "../../configs/axiosConfig";

const serviceEndpoints = {
  // ⭐ FOOD ITEMS
  getFoodItems: "v2/menu/items",
  getFoodItemsPublic: "v2/menu/items/getpublicfood",
  getFoodItemDetail: "v2/menu/items/:id",
  createFoodItem: "v2/menu/items",
  updateFoodItem: "v2/menu/items/:id",
  deleteFoodItem: "v2/menu/items/:id",

  // ⭐ MENU CATEGORY
  getMenuCategory: "v2/menu/categories",
  getMenuCategoryPublic: "v2/menu/categories/getpublicmenu",
  getMenuCategoryDetail: "v2/menu/categories/:id",

  createMenuCategory: "v2/menu/categories",
  updateMenuCategory: "v2/menu/categories/:id",
  deleteMenuCategory: "v2/menu/categories/:id",
};

const servicesApi = {
  // ⭐ GET MENU CATEGORY (private)
  getMenuCategory: async ({ operatorId }) => {
    try {
      const response = await privateClient.get(
        `${serviceEndpoints.getMenuCategory}?operatorId=${operatorId}`,
      );

      return { response };
    } catch (err) {
      console.log("err to get menu category");
      return { err };
    }
  },

  // ⭐ PUBLIC MENU CATEGORY
  getMenuCategoryPublic: async () => {
    try {
      const response = await publicClient.get(
        serviceEndpoints.getMenuCategoryPublic,
      );

      return { response };
    } catch (err) {
      console.log("err to get public menu category");
      return { err };
    }
  },

  // ⭐ CATEGORY DETAIL
  getMenuCategoryDetail: async ({ categoryId }) => {
    try {
      const response = await privateClient.get(
        serviceEndpoints.getMenuCategoryDetail.replace(":id", categoryId),
      );

      return { response };
    } catch (err) {
      console.log("err to get menu category detail");
      return { err };
    }
  },
  createMenuCategory: async (body) => {
    try {
      const response = await privateClient.post(
        serviceEndpoints.createMenuCategory,
        body,
      );
      return { response };
    } catch (err) {
      console.log("err create category");
      return { err };
    }
  },

  // UPDATE CATEGORY
  updateMenuCategory: async ({ categoryId, body }) => {
    try {
      const response = await privateClient.patch(
        serviceEndpoints.updateMenuCategory.replace(":id", categoryId),
        body,
      );
      return { response };
    } catch (err) {
      console.log("err update category");
      return { err };
    }
  },

  // DELETE CATEGORY
  deleteMenuCategory: async ({ categoryId }) => {
    try {
      const response = await privateClient.delete(
        serviceEndpoints.deleteMenuCategory.replace(":id", categoryId),
      );
      return { response };
    } catch (err) {
      console.log("err delete category");
      return { err };
    }
  },

  // GET FOOD ITEMS (ADMIN)
  getFoodItems: async ({ operatorId, categoryId }) => {
    try {
      const response = await privateClient.get(
        `${serviceEndpoints.getFoodItems}?operatorId=${operatorId}&categoryId=${categoryId}`,
      );
      return { response };
    } catch (err) {
      console.log("err get food items");
      return { err };
    }
  },

  // GET PUBLIC FOOD ITEMS
  getFoodItemsPublic: async ({ operatorId }) => {
    try {
      const response = await publicClient.get(
        `${serviceEndpoints.getFoodItemsPublic}?operatorId=${operatorId}`,
      );
      return { response };
    } catch (err) {
      console.log("err get public food items");
      return { err };
    }
  },

  // CREATE FOOD ITEM
  createFoodItem: async (body) => {
    try {
      const response = await privateClient.post(
        serviceEndpoints.createFoodItem,
        body,
      );
      return { response };
    } catch (err) {
      console.log("err create food item");
      return { err };
    }
  },

  // UPDATE FOOD ITEM
  updateFoodItem: async ({ itemId, body }) => {
    try {
      const response = await privateClient.patch(
        serviceEndpoints.updateFoodItem.replace(":id", itemId),
        body,
      );
      return { response };
    } catch (err) {
      console.log("err update food item");
      return { err };
    }
  },

  // DELETE FOOD ITEM
  deleteFoodItem: async ({ itemId }) => {
    try {
      const response = await privateClient.delete(
        serviceEndpoints.deleteFoodItem.replace(":id", itemId),
      );
      return { response };
    } catch (err) {
      console.log("err delete food item");
      return { err };
    }
  },
};

export default servicesApi;
